import { render } from "./MiniBarChart.vue?vue&type=template&id=35f92934"
import script from "./MiniBarChart.vue?vue&type=script&lang=js"
export * from "./MiniBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__